"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPassengersCountToVehicleType = transformPassengersCountToVehicleType;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPassengersCountToVehicleType(passengersCount, isLuxury, isLite) {
    // In our database vehicles with the flag `isLuxury` have a variety of `seatsCount` values ranging from 2 to 5.
    // Counterintuitevely, This method is invoked with `seatsCount` passed as a first argument most of the time.
    // For now it is unclear how we want to handle luxury vehicles with 4 or 5 seats - as the hotfix
    // we restore previous behavior of returning `VehicleType.LuxurySedan` for 3 and less `seatsCount`.
    // which is fixing most of the cases in the assignation tool.
    if (isLuxury && passengersCount <= 3) {
        return legacy_enums_1.VehicleType.LuxurySedan;
    }
    switch (passengersCount) {
        case 1:
        case 2:
        case 3:
            if (isLite) {
                return legacy_enums_1.VehicleType.SedanLite;
            }
            return legacy_enums_1.VehicleType.Sedan;
        case 4:
            if (isLite) {
                return legacy_enums_1.VehicleType.MpvLite;
            }
            if (isLuxury) {
                // throw "Luxury mpv is not available.";
            }
            return legacy_enums_1.VehicleType.Mpv;
        case 5:
        case 6:
        case 7:
            if (isLite) {
                return legacy_enums_1.VehicleType.VanLite;
            }
            if (isLuxury) {
                // throw "Luxury van is not available.";
            }
            return legacy_enums_1.VehicleType.Van;
        case 8:
        case 9:
        case 10:
            if (isLuxury) {
                // throw "Luxury shuttle is not available.";
            }
            return legacy_enums_1.VehicleType.Shuttle;
        default:
            throw new Error("No vehicle can carry more than 10 passengers.");
    }
}
//# sourceMappingURL=transformPassengersCountToVehicleType.js.map